import React from 'react';
import PageWrapper from '../../components/pageWrapper/PageWrapper';

function LecturersPage() {
    return (
        // @ts-expect-error JS component has no TS types
        <PageWrapper>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'var(--color-text-secondary)', fontSize: '1.25rem'}}>
                בקרוב
            </div>
        </PageWrapper>
    );
}

export default LecturersPage;
